<template>
	<div style="height: 100%;font-size: 25px;text-align: center;padding-top: 8rem;">
		<div style="width: 100%;height: 12rem;text-align: center;">
			<Icon type="md-information-circle" size="186" color="#5cadff" />
		</div>
		请使用微信客户端打开
	</div>
</template>
<script>
	export default {
		data(){
			return {
				
			}
		}
	}
</script>
<style>
	
</style>


// WEBPACK FOOTER //
// src/components/views/WeChat/noWxBrowser/index.vue